<!--
~ Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
~ This information is confidential and proprietary to GM Global Technology
~ Operations LLC and may not be used, modified, copied or distributed.
-->
<ngx-spinner type="ball-clip-rotate-multiple" bdColor="rgb(0,0,0,0)" color = "#00ff00"></ngx-spinner>
<gm-showcase>
  <div class="showcase-body">
    <div id="mainBody" class="showcase-body" ngForm #mainBody="ngForm">
      <br/>
      <table id="tableAccident" #tableAccident class="bordered-table" style="width: 75%">
        <tr>
          <th colspan="99" style="background-color: #C7C7C7; font-weight: bold;">
            <table style="width:100%">
              <tr>
                <td style="width:1px;">
                  <button class="btn btn-xs btn-secondary btn-group" (click)="ResetAccidentInfo(urlAccidentID)" title="Undo"><i class="fa fa-undo"></i></button>
                </td>
                <td style="text-align: center">Accident Information</td>
              </tr>
            </table>
          </th>
        </tr>
        <tr *ngIf="accident?.accidentId!=undefined || urlAccidentID==0">
          <td><label for="accident_date">Accident Date</label></td>
          <td>
            <gm-datepicker name="accident_date" id="accident_date" [ngModel]="(accident?.accidentDate!=null)? (accident?.accidentDate | date:'yyyy-MM-dd':'UTC'):null" (ngModelChange)="accident.accidentDate=$event" [minDate]="" #accident_date="ngModel" required></gm-datepicker>
            <input style="display:none" name="_accident_date" id="_accident_date" type="text" class="modelo-text-input"  [ngModel]="accident?.accidentDate | date:'yyyy-MM-dd':'UTC'">
            <small *ngIf="accident_date.errors && accident_date.errors.required" class="validationError">Required</small>
          </td>
          <td><label for="accident_time">Accident Time</label></td>
          <td>
            <input name="accident_time" id="accident_time" type="text" class="modelo-text-input" [ngModel]="accident?.fakeAccidentTime" (ngModelChange)="accident.fakeAccidentTime=$event" #accident_time="ngModel" pattern="([01]?[0-9]|2[0-3]):[0-5][0-9]" required>
            <!--<input name="accident_time" id="accident_time" type="time" class="modelo-text-input" [ngModel]="accident?.accidentTime" (ngModelChange)="accident.accidentTime=$event" #accident_time="ngModel" required>-->
            <small *ngIf="accident_time.errors && accident_time.errors.required" class="validationError">Required</small>
            <small *ngIf="accident_time.errors && accident_time.errors.pattern" class="validationError">Invalid Time format HH:mm)</small>
          </td>
          <td><label for="accident_identification">Identification</label></td>
          <td>
            <input name="accident_identification" id="accident_identification" type="text" class="modelo-text-input" [ngModel]="accident?.accidentid" (ngModelChange)="accident.accidentid=$event" #accident_identification="ngModel">
          </td>
        </tr>
        <tr *ngIf="accident?.accidentId!=undefined || urlAccidentID==0">
          <td><label for="classification">Classification</label></td>
          <td>
            <select name="classification" id="classification" [ngModel]="accident?.accidentClassificationId" (ngModelChange)="accident.accidentClassificationId=$event"  #classification="ngModel" required>
              <option *ngFor="let lo of accidentClassifications" value={{lo.accidentClassificationId}}>
                {{lo.classification}}
              </option>
            </select>
            <input style="display:none" name="{{'_classification'+ index}}" id="{{'_classification'+ index}}" type="text" class="modelo-text-input"  [ngModel]="accident?.classification">
            <small *ngIf="classification.errors && classification.errors.required" class="validationError">Required</small>
          </td>
          <td><label for="causation">Causation</label></td>
          <td colspan="3">
            <select name="causation" id="causation" [ngModel]="accident?.accidentCausationId" (ngModelChange)="accident.accidentCausationId=$event" #causation="ngModel" required>
              <option *ngFor="let lo of accidentCausations" value={{lo.accidentCausationId}}>
                {{lo.causation}}
              </option>
            </select>
            <input style="display:none" name="_causation" id="_causation" type="text" class="modelo-text-input"  [ngModel]="accident?.causation">
            <small *ngIf="causation.errors && causation.errors.required" class="validationError">Required</small>
          </td>
        </tr>
        <tr *ngIf="accident?.accidentId!=undefined || urlAccidentID==0">
          <td><label for="accident_site">Site</label></td>
          <td>
            <select name="accident_site" id="accident_site" [ngModel]="accident?.siteId" (ngModelChange)="accident.siteId=$event" (change)="changeSite($event,accident.siteId)" #accident_site="ngModel" required>
              <option *ngFor="let si of sites" value={{si.siteId}}>
                {{si.siteName}}
              </option>
            </select>
            <input style="display:none" name="_accident_site" id="_accident_site" type="text" class="modelo-text-input"  [ngModel]="accident?.siteName">
            <small *ngIf="accident_site.errors && accident_site.errors.required" class="validationError">Required</small>
          </td>
          <td><label for="accident_locationType">Location Category</label></td>
          <td>
            <select name="accident_locationType" id="accident_locationType" [ngModel]="accident?.locationTypeId" (ngModelChange)="accident.locationTypeId=$event" style="width:100px" (change)="changeLocationType($event,accident.locationTypeId)" #accident_locationType="ngModel" required>
              <option *ngFor="let lo of locationTypes" value={{lo.locationTypeId}}>
                {{lo.locationType}}
              </option>
            </select>
            <input style="display:none" name="_accident_locationType" id="_accident_locationType" type="text" class="modelo-text-input"  [ngModel]="accident?.locationTypeName">
            <small *ngIf="accident_locationType.errors && accident_locationType.errors.required" class="validationError">Required</small>
          </td>
          <td><label for="accident_location">Location Area</label></td>
          <td>
            <select name="accident_location" id="accident_location" style="width:200px" [ngModel]="accident?.locationId" (ngModelChange)="accident.locationId=$event"  #accident_location="ngModel" required>
              <option *ngFor="let lo of locations" value={{lo.locationId}}>
                {{lo.locationName}}
              </option>
            </select>
            <input style="display:none" name="_accident_location" id="_accident_location" type="text" class="modelo-text-input"  [ngModel]="accident?.locationName">
            <small *ngIf="accident_location.errors && accident_location.errors.required" class="validationError">Required</small>
          </td>
        </tr>
        <tr *ngIf="accident?.accidentId!=undefined || urlAccidentID==0">
          <td><label>Sub. Location</label></td>
          <td colspan="5">
            <input name="accident_sub_location" id="accident_sub_location" type="text" class="modelo-text-input" [ngModel]="accident?.subLocation" (ngModelChange)="accident.subLocation=$event" maxlength="50">
          </td>
        </tr>
        <tr *ngIf="accident?.accidentId!=undefined || urlAccidentID==0">
          <td><label for="accidentComment">Comment:</label></td>
          <td colspan="5"><textarea name="accidentComment" id="accidentComment" [ngModel]="accident?.comment" (ngModelChange)="accident.comment=$event" class="modelo-text-input" cols="130" rows="3"></textarea></td>
        </tr>
      </table>

      <table #tableAccidentVehicle id="tableAccidentVehicle" class="bordered-table" *ngIf="accident?.accidentId!=undefined && accident?.accidentId!=0">
        <tr>
          <th colspan="99" style="background-color: #C7C7C7; font-weight: bold;">
            <table style="width:100%">
              <tr>
                <td style="width:1px;"><button class="btn btn-xs btn-secondary btn-group" (click)="AddAccidentVehicle(tableAccidentVehicle)"><i class="fa fa-plus"></i></button></td>
                <td style="width:1px;">
                  <button class="btn btn-xs btn-secondary btn-group" (click)="ResetAccidentVehicle(tableAccidentVehicle)"><i class="fa fa-undo"></i></button>
                </td>
                <td style="width:355px"><span style="font-size:0.7em; color:darkred">(Note: ) Reset Vehicle Information will reset Person Information too.</span></td>
                <td style="text-align: center; margin-right: 250px;">Vehicle Information</td>
                <td style="text-align: -webkit-right" width="200px">
                  <input id="accidentVehicleRequired" name="accidentVehicleRequired" type="hidden" [ngModel]="accidentVehicles[0]?.vin" (ngModelChange)="accidentVehicles[0].vin=$event" #accidentVehicleRequired="ngModel" required>
                  <span style="font-size:0.7em;" *ngIf="accidentVehicleRequired.errors && accidentVehicleRequired.errors.required" class="validationError">At Least One Vehicle Required</span>
                </td>
              </tr>
            </table>

          </th>
        </tr>
        <tr>
          <td *ngIf="isSuperAdmin"></td>
          <td><label>Vehicle #</label></td>
          <td><label>VIN</label></td>
          <td><label>Crash Object</label></td>
          <td><label>Vehicle Direction</label></td>
          <td><label>Project Code</label></td>
        </tr>
        <tr *ngFor="let item of accidentVehicles; let index = index; trackBy:trackByIndex">
          <td *ngIf="isSuperAdmin"><button class="btn btn-xs btn-primary" (click)="deleteAccidentVehicle(item.accidentVehicleId, index)"><i class="fa fa-trash"></i></button></td>
          <td>
            <input  name="{{'accident_vehicle'+ index}}" id="{{'accident_vehicle'+ index}}" type="text" class="modelo-text-input"  [(ngModel)]="item.gmVehicleNumber">
          </td>
          <td>
            <input  name="{{'accident_vin'+ index}}" id="{{'accident_vin'+ index}}" type="text" class="modelo-text-input"  [(ngModel)]="item.vin" #accident_vin="ngModel" required>
            <small *ngIf="accident_vin.errors && accident_vin.errors.required" class="validationError">Required</small>
          </td>
          <td>
            <select name="{{'crash_object'+index}}" [(ngModel)]="item.crashObjectDefinitionId" #crash_object="ngModel" required>
              <option *ngFor="let si of crashObjects" value={{si.crashObjectDefinitionId}}>
                {{si.crashObjectType}}
              </option>
            </select>
            <input style="display:none" name="{{'_crash_object'+ index}}" id="{{'_crash_object'+ index}}" type="text" class="modelo-text-input"  [ngModel]="item.crashObjectType">
            <small *ngIf="crash_object.errors && crash_object.errors.required" class="validationError">Required</small>
          </td>
          <td>
            <select name="{{'vehicle_direction'+index}}" [(ngModel)]="item.vehicleDirectionDefinitionId" #vehicle_direction="ngModel" required>
              <option *ngFor="let si of vehicledirectiondefinitions" value={{si.vehicleDirectionDefinitionId}}>
                {{si.vehicleDirection}}
              </option>
            </select>
            <input style="display:none" name="{{'_vehicle_direction'+ index}}" id="{{'_vehicle_direction'+ index}}" type="text" class="modelo-text-input"  [ngModel]="item.vehicleDirection">
            <small *ngIf="vehicle_direction.errors && vehicle_direction.errors.required" class="validationError">Required</small>
          </td>
          <td>
            <input name="{{'project_code'+ index}}" id="{{'project_code'+ index}}" type="text" class="modelo-text-input"  [(ngModel)]="item.vehicleProjectCode" size="20">
          </td>
        </tr>
      </table>

      <table #tableAccidentPerson id="tableAccidentPerson" class="bordered-table" *ngIf="accident?.accidentId!=undefined && accidentVehicles[0]?.accidentVehicleId!=undefined && !AreAllVehiclesDeleted">
        <tr>
          <th colspan="99" style="background-color: #C7C7C7; font-weight: bold;">
            <table style="width:100%">
              <tr>
                <td style="width:1px;"><button class="btn btn-xs btn-secondary btn-group" (click)="AddAccidentPerson(tableAccidentPerson)"><i class="fa fa-plus"></i></button></td>
                <td style="width:1px;">
                  <button class="btn btn-xs btn-secondary btn-group" (click)="ResetAccidentPerson(tableAccidentPerson)"><i class="fa fa-undo"></i></button>
                </td>
                <td style="text-align: center">Person Information</td>
                <td style="text-align: -webkit-right" width="200px">
                  <input id="accidentPersonRequired" name="accidentPersonRequired" type="hidden" [ngModel]="persons[0]?.lastName" (ngModelChange)="persons[0].lastName=$event" #accidentPersonRequired="ngModel" required>
                  <span style="font-size:0.7em;" *ngIf="accidentPersonRequired.errors && accidentPersonRequired.errors.required" class="validationError">At Least One Driver Required</span>
                </td>
              </tr>
            </table>

          </th>
        </tr>
        <tr>
          <td *ngIf="isSuperAdmin"></td>
          <td><label>Vehicle VIN</label></td>
          <td><label>Person Type</label></td>
          <td><label>Injury</label></td>
          <td><label>GMIN</label></td>
          <td><label>First Name</label></td>
          <td><label>Last Name</label></td>
          <td><label>Email</label></td>
          <td><label>Phone</label></td>
          <td><label>Company</label></td>
          <td><label>Action</label></td>
        </tr>
        <tr *ngFor="let item of accidentVehiclePersons; let index = index; trackBy:trackByIndex">
          <td *ngIf="isSuperAdmin"><button id="{{'accident_vehicle_person_delete_button'+index}}" class="btn btn-xs btn-primary" (click)="deleteAccidentPerson(item.accidentVehiclePersonId, index)"><i class="fa fa-trash"></i></button></td>
          <td>
            <select selectForVehicle="" name="{{'accident_vehicle_person_vin'+index}}" id="{{'accident_vehicle_person_vin'+index}}" [ngModel]="item.accidentVehicleId" (ngModelChange)="item.accidentVehicleId=$event" #accident_vehicle_person_vin="ngModel" required>
              <option *ngFor="let si of filteredAccidentVehicles" value={{si.accidentVehicleId}}>
                {{si.vin}}
              </option>
            </select>
            <input style="display:none" name="{{'_accident_vehicle_person_vin'+ index}}" id="{{'_accident_vehicle_person_vin'+ index}}" type="text" class="modelo-text-input"  [ngModel]="item.accidentVehicleVIN">
            <small *ngIf="accident_vehicle_person_vin.errors && accident_vehicle_person_vin.errors.required" class="validationError">Required</small>
          </td>
          <td>
            <select selectForType="" name="{{'accident_person'+index}}" id="{{'accident_person'+index}}"  (change)="ChangeAccidentPersonType(index)" [(ngModel)]="item.accidentPersonTypeId" #accident_person="ngModel" required>
              <option *ngFor="let si of accidentPersonTypes" value={{si.accidentPersonTypeId}}>
                {{si.type}}
              </option>
            </select>
            <input style="display:none" name="{{'_accident_person'+ index}}" id="{{'_accident_person'+ index}}" type="text" class="modelo-text-input"  [ngModel]="item.accidentPersonType">
            <small *ngIf="accident_person.errors && accident_person.errors.required" class="validationError">Required</small>
          </td>
          <td>
            <select name="{{'accident_injury'+index}}" id="{{'accident_injury'+index}}" [(ngModel)]="item.injuryClassificationId" #accident_injury="ngModel" required>
              <option *ngFor="let si of injuryClassifications" value={{si.injuryClassificationId}}>
                {{si.injuryClassification}}
              </option>
            </select>
            <input style="display:none" name="{{'_accident_injury'+ index}}" id="{{'_accident_injury'+ index}}" type="text" class="modelo-text-input"  [ngModel]="item.injuryClassification">
            <small *ngIf="accident_injury.errors && accident_injury.errors.required" class="validationError">Required</small>
          </td>
          <td><span>{{persons[index]?.identificationId}}</span></td>
          <td>
            <span>{{persons[index]?.firstName}}</span>
            <input id="{{'accident_firstName' + index}}" name="{{'accident_firstName' + index}}" type="hidden" [ngModel]="persons[index]?.firstName" (ngModelChange)="persons[index].firstName=$event" #accident_firstName="ngModel" required>
            <small *ngIf="accident_firstName.errors && accident_firstName.errors.required" class="validationError">Required</small>
          </td>
          <td>
            <span>{{persons[index]?.lastName}}</span>
            <input id="{{'accident_lastName' + index}}" name="{{'accident_lastName' + index}}" type="hidden" [ngModel]="persons[index]?.lastName" (ngModelChange)="persons[index].lastName=$event" #accident_lastName="ngModel" required>
            <small *ngIf="accident_lastName.errors && accident_lastName.errors.required" class="validationError">Required</small>
          </td>
          <td><span>{{persons[index]?.email}}</span></td>
          <td><span>{{persons[index]?.phoneNumber}}</span></td>
          <td><span>{{persons[index]?.company}}</span></td>
          <td>
            <button id="{{'accident_person_search' + index}}" class="btn btn-xs btn-secondary btn-group" (click)="OpenSearchModal(index,item.accidentPersonTypeId)" data-target="#DriverSearchModal"><i class="fa fa-search"></i></button>
          </td>
        </tr>
      </table>
    </div>
    <div class="modal fade" id="DriverSearchModal" tabindex="-1" role="dialog" aria-labelledby="SearchModal" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered custom-center" role="document">
        <div class="modal-content" style="min-width: 1232px">
          <div class="modal-header">
            <button type="button" class="close" (click)="setDefaultUrl()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <button #closeModal type="button" class="closeModal" personType="-1"  personid="-1" personIndex="-1" (click)="CloseSearch(closeModal)" style="display:none;"></button>
          </div>
          <div class="holds-the-iframe">
            <iframe id="searchPersons"
                    title="Search Detail"
                    width="1230px"
                    height="800px"
                    frameborder="0"
                    scrolling="yes"
                    marginheight="5"
                    marginwidth="5"
                    src="driverSearchAdd/?modalpopup=1&accident=1">
            </iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</gm-showcase>
<div style="z-index:1; position:absolute; margin-left: 80px; margin-top: 6px;">
  <button id="SaveChange" #SaveChange class="btn btn-primary-white btn-group" [disabled]="!mainBody.valid" (click)="SaveAccident()"><i class="fa fa-save"></i>&nbsp;Save</button>&nbsp;
  <button id="ResetChange" #ResetChange  class="btn btn-primary-white btn-group" onclick="window.location.reload()"><i class="fa fa-refresh"></i>&nbsp;Reset</button>&nbsp;&nbsp;
  <button id="BackToDriverPage" #BackToDriverPage  class="btn btn-primary-white btn-group"><i class="fa fa-backward"></i>&nbsp;Back To Driver Detail</button>
  <span style="color: White; font-weight: bold;"> {{returnMessage}}</span>
